import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react'
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import moment from 'moment';
import esLocale from '@fullcalendar/core/locales/es';
import './Disponibilidad.css';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faEye } from '@fortawesome/free-solid-svg-icons';
import { fetchUsuario, getUsuario } from '../user';
import Select from 'react-select';
import baseURL from '../url';
import Helper from '../../Helpers/helpers';
import TurnoModal from '../Modals/TurnoModal';

import enviarPdfAlServidor from "../Dias/DescargarCitaPdf";

import dayjs from 'dayjs';
import 'dayjs/locale/es';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es');

const Disponibilidad = () => {

    const color1 = getComputedStyle(document.documentElement).getPropertyValue('--color1');
    const [turnos, setTurnos] = useState([]);
    const [turnoSeleccionado, setTurnoSeleccionado] = useState(null); // Estado para el turno seleccionado
    const [modalIsOpen, setModalIsOpen] = useState(false); // Estado para abrir o cerrar el modal

    const [nombre, setNombre] = useState("");
    const [telefono, setTelefono] = useState("");
    const [motivoInactivo, setMotivoInactivo] = useState([]);

    const [nuevaFecha, setNuevaFecha] = useState("");
    const [periodicidad, setPeriodicidad] = useState("");

    const [nuevaHoraInicio, setNuevaHoraInicio] = useState("");
    const [nuevaHoraFin, setNuevaHoraFin] = useState("");

    const [nuevoComentario, setNuevoComentario] = useState("");
    const [comentarioActualizado, setComentarioActualizado] = useState(0); //se usa para saber cuando se agrego un comentario
    const [cancelarActualizado, setCancelarActualizado] = useState(0); //se usa para saber cuando se hizo una cancelacion

    const [nuevoEstado, setNuevoEstado] = useState('');
    const [servicios, setServicios] = useState([]);
    const [servicioSeleccionado, setServicioSeleccionado] = useState(null); // Establecer el servicio seleccionado por defecto
    const [serviciosFiltrados, setServiciosFiltrados] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [selectedEstados, setSelectedEstados] = useState(['asignado']);
    const [terapeutas, setTerapeutas] = useState([]);
    const [terapeutaSeleccionado, setTerapeutaSeleccionado] = useState('');
    const [salas, setSalas] = useState([]);
    const [salaSeleccionada, setSalaSeleccionada] = useState('');
    const [categorias, setCategorias] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('');
    const [categoriaFiltrada, setCategoriaFiltrada] = useState(null);

    const [citasSeleccionadas, setCitasSeleccionadas] = useState([]); //seleccionadas para cancelarse

    const [resources, setResources] = useState([]); //arreglo de salas para el calendario


    //Trae usuario logueado-----------------------------
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            await fetchUsuario();
            setLoading(false);
        };

        fetchData();
    }, []);
    const usuarioLegued = getUsuario();

    useEffect(() => {
        cargarTurnos();
        cargarServicios();
        cargarUsuarios();
        cargarCategorias();
    }, []);

    // Establecer Ceseco principal por defecto cuando hay filtro disponible (admin, direccion, terapeuta)
    const cesecoAsignadoId = usuarioLegued?.idCategoria;
    const esAdminODireccion = usuarioLegued?.rol === 'admin' || usuarioLegued?.rol === 'direccion';
    const esTerapeuta = usuarioLegued?.rol === 'terapeuta';

    useEffect(() => {
        if ((esAdminODireccion || esTerapeuta) &&
            categorias.length > 0 &&
            !categoriaFiltrada) {
            const cesecoPrincipal = usuarioLegued?.cesecoPrincipal || 
                                   usuarioLegued?.categorias?.find(c => c.esPrincipal === 1 || c.esPrincipal === '1') ||
                                   (cesecoAsignadoId && categorias.find(cat => cat.idCategoria === cesecoAsignadoId));
            
            if (cesecoPrincipal) {
                const cesecoEnLista = categorias.find(cat => 
                    cat.idCategoria === cesecoPrincipal.idCategoria || 
                    cat.idCategoria === cesecoPrincipal ||
                    (esTerapeuta && usuarioLegued?.idCategorias?.includes(cat.idCategoria))
                );
                
                if (cesecoEnLista) {
                    setCategoriaFiltrada({ value: cesecoEnLista.idCategoria, label: cesecoEnLista.categoria });
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categorias.length, esAdminODireccion, esTerapeuta, cesecoAsignadoId]);

    // Establecer servicio principal por defecto cuando se carguen los servicios
    useEffect(() => {
        if (servicios.length > 0 && usuarioLegued && serviciosFiltrados.length === 0) {
            // Buscar el servicio principal del usuario
            const servicioPrincipal = usuarioLegued.servicioPrincipal || 
                                     usuarioLegued.servicios?.find(s => s.esPrincipal === 1 || s.esPrincipal === '1') ||
                                     (usuarioLegued.idServicio && servicios.find(s => s.idServicio === usuarioLegued.idServicio));
            
            if (servicioPrincipal) {
                const servicioEnLista = servicios.find(s => {
                    // Si hay Ceseco filtrado, verificar que el servicio pertenezca a ese Ceseco
                    if (categoriaFiltrada) {
                        if (s.idCategoria !== categoriaFiltrada.value) return false;
                    } else {
                        // Verificar que el servicio pertenezca a uno de los Cesecos asignados
                        const perteneceACeseco = usuarioLegued?.idCategorias?.includes(s.idCategoria) ||
                                                s.idCategoria === usuarioLegued.idCategoria;
                        if (!perteneceACeseco) return false;
                    }
                    
                    // Para coord_ceseco: todos los servicios de sus Cesecos
                    if (usuarioLegued?.rol === 'coord_ceseco') {
                        return s.idServicio === servicioPrincipal.idServicio || s.idServicio === servicioPrincipal;
                    }
                    
                    // Para coord_programa: solo servicios asignados
                    if (usuarioLegued?.rol === 'coord_programa') {
                        return (s.idServicio === servicioPrincipal.idServicio || s.idServicio === servicioPrincipal) &&
                               (usuarioLegued?.idServicios?.includes(s.idServicio) || usuarioLegued?.idServicio === s.idServicio);
                    }
                    
                    // Para admin y direccion: todos
                    if (['admin', 'direccion'].includes(usuarioLegued?.rol)) {
                        return s.idServicio === servicioPrincipal.idServicio || s.idServicio === servicioPrincipal;
                    }
                    
                    // Para terapeuta: servicios asignados
                    if (usuarioLegued?.rol === 'terapeuta') {
                        return (s.idServicio === servicioPrincipal.idServicio || s.idServicio === servicioPrincipal) &&
                               (usuarioLegued?.idServicios?.includes(s.idServicio) || usuarioLegued?.idServicio === s.idServicio);
                    }
                    
                    return false;
                });
                
                if (servicioEnLista) {
                    setServiciosFiltrados([{ value: servicioEnLista.idServicio, label: servicioEnLista.titulo }]);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [servicios.length, usuarioLegued?.idServicio, usuarioLegued?.servicioPrincipal?.idServicio, categoriaFiltrada?.value]);

    // Cargar salas solo cuando cambie la categoría filtrada o el usuario
    const categoriaFiltradaId = categoriaFiltrada?.value;
    const usuarioId = usuarioLegued?.idUsuario;
    const usuarioIdCategoria = usuarioLegued?.idCategoria;
    
    useEffect(() => {
        if (usuarioId) {
            cargarSalas();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoriaFiltradaId, usuarioId, usuarioIdCategoria]);

    const cargarTurnos = () => {
        return fetch(`${baseURL}/turnoGet.php?idUser=${usuarioLegued.idUsuario}`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const turnosConDias = data.turnos?.map(turno => ({
                    ...turno,
                    dias: JSON.parse(turno.dias)
                })) || [];

                setTurnos(turnosConDias);
                return turnosConDias;
            })
            .catch(error => {
                console.error('Error al cargar turnos:', error);
                return [];
            });
    };

    const cargarServicios = () => {
        fetch(`${baseURL}/serviciosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setServicios(data.servicios || []);
                if (data.servicios && data.servicios.length > 0) {
                    setServicioSeleccionado(data.servicios[0].idServicio); // Selecciona el primer servicio por defecto
                }
            })
            .catch(error => console.error('Error al cargar servicios:', error));
    };

    const cargarUsuarios = () => {
        fetch(`${baseURL}/usuariosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setTerapeutas(data.usuarios.filter(usuario => (usuario.rol === "terapeuta")) || []);
            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const cargarSalas = () => {
        fetch(`${baseURL}/salasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                let salasFiltradas;
                
                    // Si es admin o direccion y hay categoría filtrada, usar esa
                    if ((usuarioLegued?.rol === 'admin' || usuarioLegued?.rol === 'direccion') &&
                        categoriaFiltrada) {
                        salasFiltradas = data.salas.filter(
                            sala => sala.idTienda === categoriaFiltrada.value
                        );
                    } else {
                        // Para otros roles, usar sus categorías asignadas (múltiples Cesecos)
                        if (usuarioLegued?.idCategorias && usuarioLegued.idCategorias.length > 0) {
                            salasFiltradas = data.salas.filter(
                                sala => usuarioLegued.idCategorias.includes(sala.idTienda)
                            );
                        } else {
                            // Fallback: usar categoría principal
                            salasFiltradas = data.salas.filter(
                    sala => sala.idTienda === usuarioLegued.idCategoria
                );
                        }
                    }

                setSalas(salasFiltradas || []);

                const recursos = salasFiltradas.map(sala => ({
                    id: sala.idSala,
                    title: sala.nombre
                }));

                setResources(recursos);

            })
            .catch(error => console.error('Error al cargar usuarios:', error));
    };

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                const categoriasOrdenadas = (data?.categorias || [])?.sort((a, b) => a.orden - b.orden);
                setCategorias(categoriasOrdenadas);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const handleSelectEvent = (info) => {

        const id = Number(info.event.id);

        // Filtrar el turno seleccionado por su idTurno
        const turnoSeleccionado = turnos.find(item => item.idTurno === id);

        if (turnoSeleccionado) {
            setModalIsOpen(true);
            setTurnoSeleccionado(turnoSeleccionado); // Establecer el turno seleccionado
            setTerapeutaSeleccionado(turnoSeleccionado.idTerapeuta);
            setSalaSeleccionada(turnoSeleccionado.idSala);
        }
    };

    const handleCloseModal = () => {
        setModalIsOpen(false); // Cerrar el modal
    };

    const handleFilterChange = (e) => {
        setFilterText(e.target.value.toLowerCase());
    };

    const filteredTurnos = Helper.filterTurnosByEstados({
        turnos: turnos?.filter(turno => {
            const pasaFiltroServicios = serviciosFiltrados.length === 0 || 
                serviciosFiltrados.map(servicio => servicio.value).includes(turno?.idServicio);
            
            // Filtro por categoría (Ceseco) - para admin, direccion y terapeuta
            let pasaFiltroCategoria = true;
            if ((usuarioLegued?.rol === 'admin' || 
                 usuarioLegued?.rol === 'direccion' || 
                 usuarioLegued?.rol === 'terapeuta') && 
                categoriaFiltrada) {
                pasaFiltroCategoria = turno?.idCategoriaSala === categoriaFiltrada.value;
            }
            
            // Para coord_ceseco y coord_programa: si no hay filtros, mostrar turnos de todos sus Cesecos asignados
            if ((usuarioLegued?.rol === 'coord_ceseco' || usuarioLegued?.rol === 'coord_programa') && 
                serviciosFiltrados.length === 0 && !categoriaFiltrada) {
                const tieneAcceso = usuarioLegued?.idCategorias?.includes(turno?.idCategoriaSala) ||
                                   turno?.idCategoriaSala === usuarioLegued?.idCategoria;
                return tieneAcceso && 
                       (turno?.idSala && turno.idTerapeuta !== null) &&
                       pasaFiltroServicios;
            }
            
            // Para terapeuta: si no hay filtro de Ceseco, mostrar turnos de todos sus Cesecos asignados
            if (usuarioLegued?.rol === 'terapeuta' && 
                serviciosFiltrados.length === 0 && !categoriaFiltrada) {
                const tieneAcceso = usuarioLegued?.idCategorias?.includes(turno?.idCategoriaSala) ||
                                   turno?.idCategoriaSala === usuarioLegued?.idCategoria;
                return tieneAcceso && 
                       (turno?.idSala && turno.idTerapeuta !== null) &&
                       pasaFiltroServicios;
            }
            
            return (turno?.idSala && turno.idTerapeuta !== null) &&
                   pasaFiltroServicios && 
                   pasaFiltroCategoria;
        }),
        selectedEstados,
        usuarioLegued,
        filterText,
        serviciosFiltrados: [] // ya filtrado arriba
    });

    // Filtro de turnos ajustado para admin y colaborador
    const events = filteredTurnos.map(turno => {
        return turno.dias.map(dia => {
            const startDateTime = `${dia.dia}T${dia.horaInicio}:00`;
            const endDateTime = `${dia.dia}T${dia.horaFin}:00`;

            return {
                id: turno.idTurno,
                title: `${turno.nombre} - ${turno.servicio}`,
                start: startDateTime,
                end: endDateTime,
                resourceId: turno.idSala,
                description: turno.servicio,
                estado: turno.estado,
                color: turno.estado === 'Asignado' ? '#06b5b8' : 'grey',
            };
        });
    }).flat();

    useEffect(() => {
        // Actualiza el valor del select cuando cambia el estado nuevoEstado
        setNuevoEstado(turnoSeleccionado?.estado);
    }, [turnoSeleccionado]);

    const handleUpdateText = async (idTurno) => {

        if (nuevoEstado == 'Asignado') {
            //crear pdf
            const detallesTurno = {
                idTurno: idTurno,
                servicio: turnoSeleccionado.servicio,
                dia: dayjs(turnoSeleccionado.dias[0].dia).format('dddd'),
                fecha: dayjs(turnoSeleccionado.dias[0].dia).format('dddd, D [de] MMMM [de] YYYY'),
                horarioInicio: turnoSeleccionado.dias[0].horaInicio,
                horarioFin: turnoSeleccionado.dias[0].horaFin,
                nombre,
                telefono,
                categoria: turnoSeleccionado.nombreCategoria,
                ubicacionTienda: turnoSeleccionado.mapaUrlTienda,
            };
            enviarPdfAlServidor(detallesTurno);
        }


        try {

            const payload = {
                idTurno: idTurno,
                nombre: nombre,
                telefono: telefono,
                idServicio: Number(servicioSeleccionado),
                idTerapeuta: terapeutaSeleccionado ? terapeutaSeleccionado : null,
                idSala: salaSeleccionada ? salaSeleccionada : null,
                estado: nuevoEstado !== '' ? nuevoEstado : turnoSeleccionado.estado,
                motivo_inactivo: motivoInactivo != '' ? motivoInactivo : null
            };

            fetch(`${baseURL}/turnoPut.php?idTurno=${idTurno}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
                .then(response => response.json())
                .then(async (data) => {
                    if (data.error) {
                        Swal.fire(
                            'Error!',
                            data.error,
                            'error'
                        );
                    } else {
                        Swal.fire(
                            'Actualización exitosa',
                            data.mensaje,
                            'success'
                        );
                        const nuevosTurnos = await cargarTurnos();
                        const turnoSeleccionado = nuevosTurnos.find(item => item.idTurno === idTurno);
                        setTurnoSeleccionado({ ...turnoSeleccionado });
                    }
                })
                .catch(error => {
                    Swal.fire(
                        'Error!',
                        error.message,
                        'error'
                    );
                });
        } catch (error) {
            Swal.fire(
                'Error!',
                error.message,
                'error'
            );
        }
    };

    const handleUpdateDate = async (idTurno) => {
        try {

            const payload = {
                idTurno: idTurno,
                nuevaFecha: nuevaFecha,
                periodicidad: periodicidad,
                nuevaHoraInicio: nuevaHoraInicio,
                nuevaHoraFin: nuevaHoraFin
            };

            fetch(`${baseURL}/turnoFechaHoraPut.php?idTurno=${idTurno}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            })
                .then(response => response.json())
                .then(async (data) => {
                    if (data.error) {
                        Swal.fire(
                            'Error!',
                            data.error,
                            'error'
                        );
                    } else {
                        Swal.fire(
                            'Actualización exitosa',
                            data.mensaje,
                            'success'
                        );
                        const nuevosTurnos = await cargarTurnos();
                        const turnoSeleccionado = nuevosTurnos.find(item => item.idTurno === idTurno);
                        setTurnoSeleccionado({ ...turnoSeleccionado });
                    }
                })
                .catch(error => {
                    Swal.fire(
                        'Error!',
                        error.message,
                        'error'
                    );
                });
        } catch (error) {
            Swal.fire(
                'Error!',
                error.message,
                'error'
            );
        }
    };

    const handleInsertComment = async (idTurno, tipo) => {
        if (tipo === 3 && nuevoEstado != 'Asignado') {
            Swal.fire('Error!', 'Para poder programar citas el estado de la cita debe ser Asignado', 'error');
        } else {
            try {

                const formData = new FormData();
                formData.append('idTurno', idTurno);
                formData.append('idTerapeuta', usuarioLegued.idUsuario);
                formData.append('comentario', nuevoComentario);
                formData.append('tipo_de_comentario', tipo);
                formData.append('periodicidad', periodicidad);

                fetch(`${baseURL}/comentarioPost.php`, {
                    method: 'POST',
                    body: formData,
                })
                    .then(response => response.json())
                    .then(async (data) => {
                        if (data.error) {
                            Swal.fire(
                                'Error!',
                                data.error,
                                'error'
                            );
                        } else {
                            if (tipo === 4) {
                                //creamos el pdf
                                const idTurnoNuevo = Number(data.turno);
                                const nuevaFecha = data.fecha;

                                const detallesTurno = {
                                    idTurno: idTurnoNuevo,
                                    servicio: turnoSeleccionado.servicio,
                                    dia: dayjs(nuevaFecha).format('dddd'),
                                    fecha: dayjs(nuevaFecha).format('dddd, D [de] MMMM [de] YYYY'),
                                    horarioInicio: turnoSeleccionado.dias[0].horaInicio,
                                    horarioFin: turnoSeleccionado.dias[0].horaFin,
                                    nombre: turnoSeleccionado.nombre,
                                    telefono: turnoSeleccionado.telefono,
                                    categoria: turnoSeleccionado.nombreCategoria,
                                    ubicacionTienda: turnoSeleccionado.mapaUrlTienda,
                                };
                                enviarPdfAlServidor(detallesTurno);
                            }
                            if (tipo === 3) {
                                //creamos los pdfs
                                const idsTurnosNuevos = data.turnos;
                                const nuevasFechas = data.fechas;

                                idsTurnosNuevos.forEach((idTurnoNuevo, index) => {
                                    const nuevaFecha = nuevasFechas[index];

                                    const detallesTurno = {
                                        idTurno: Number(idTurnoNuevo),
                                        servicio: turnoSeleccionado.servicio,
                                        dia: dayjs(nuevaFecha).format('dddd'),
                                        fecha: dayjs(nuevaFecha).format('dddd, D [de] MMMM [de] YYYY'),
                                        horarioInicio: turnoSeleccionado.dias[0].horaInicio,
                                        horarioFin: turnoSeleccionado.dias[0].horaFin,
                                        nombre: turnoSeleccionado.nombre,
                                        telefono: turnoSeleccionado.telefono,
                                        categoria: turnoSeleccionado.nombreCategoria,
                                        ubicacionTienda: turnoSeleccionado.mapaUrlTienda,
                                    };

                                    enviarPdfAlServidor(detallesTurno);
                                });
                            }
                            Swal.fire(
                                'Actualización exitosa',
                                data.mensaje,
                                'success'
                            );
                            const nuevosTurnos = await cargarTurnos();
                            const turnoSeleccionadoNuevo = nuevosTurnos.find(item => item.idTurno === idTurno);
                            setTurnoSeleccionado({ ...turnoSeleccionadoNuevo });
                            setComentarioActualizado((prev) => prev + 1);
                        }
                    })
                    .catch(error => {
                        Swal.fire(
                            'Error!',
                            error.message,
                            'error'
                        );
                    });
            } catch (error) {
                Swal.fire(
                    'Error!',
                    error.message,
                    'error'
                );
            }
        }
    };

    const handleCancelar = () => {
        if (citasSeleccionadas.length > 0) {

            try {

                const payload = {
                    turnos: citasSeleccionadas
                };

                fetch(`${baseURL}/turnoCancelarPut.php`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                })

                    .then(response => response.json())
                    .then(async (data) => {
                        if (data.error) {
                            Swal.fire(
                                'Error!',
                                data.error,
                                'error'
                            );
                        } else {
                            Swal.fire(
                                'Actualización exitosa',
                                data.mensaje,
                                'success'
                            );
                            const nuevosTurnos = await cargarTurnos();
                            const turnoSeleccionadoNuevo = nuevosTurnos.find(item => item.idTurno === turnoSeleccionado.idTurno);
                            setTurnoSeleccionado({ ...turnoSeleccionadoNuevo });

                            setCancelarActualizado((prev) => prev + 1);
                        }
                    })
                    .catch(error => {
                        Swal.fire(
                            'Error!',
                            error.message,
                            'error'
                        );
                    });
            } catch (error) {
                Swal.fire(
                    'Error!',
                    error.message,
                    'error'
                );
            }

        }

    };

    const handleSelectServicio = (idServicio) => {
        setServicioSeleccionado(idServicio); // Establece el servicio seleccionado
    };

    const eliminar = (idTurno) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/turnoDelete.php?idTurno=${idTurno}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            // Si el servidor devuelve un error, mostramos un mensaje de error
                            Swal.fire(
                                'Error',
                                data.error,
                                'error'
                            );
                        } else {
                            // Si la categoría se eliminó correctamente, mostramos un mensaje de éxito
                            Swal.fire(
                                '¡Eliminado!',
                                data.mensaje,
                                'success'
                            );
                            cargarTurnos();
                            handleCloseModal()
                        }
                    })
                    .catch(error => {
                        console.error('Error al eliminar contacto:', error);
                        Swal.fire(
                            'Error',
                            'Ocurrió un problema al intentar eliminar la categoría.',
                            'error'
                        );
                    });
            }
        });
    };

    // Estilos personalizados para los <Select/>
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? color1 : 'white',
            color: state.isSelected ? 'white' : 'black',
        }),
        control: (provided) => ({
            ...provided,
            maxHeight: '32px',
            overflowY: 'auto',
            paddingRight: '30px',
            borderRadius: '8px',
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: '8px',

        }),
        clearIndicator: (provided) => ({
            ...provided,
            position: 'absolute',
            right: '20px',
            top: '2px',
            zIndex: 1,
            width: '50px',
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            position: 'absolute',
            right: '-5px',
            top: '2px',
            zIndex: 1,
        }),
    };

    const alertAsignarSala = (turno) => {

        Swal.fire({
            icon: 'question',
            html:
                `La cita para el día <strong>${moment(turno.dias[0].dia).format('DD/MM/YYYY')}</strong> de <strong>${moment(`${turno.dias[0].dia} ${turno.dias[0].horaInicio}`).format('hh:mm a')} a ${moment(`${turno.dias[0].dia} ${turno.dias[0].horaFin}`).format('hh:mm a')}</strong> será asignada al terapeuta <strong>${terapeutas.filter(terapeuta => terapeuta.idUsuario == terapeutaSeleccionado)[0].nombre}</strong> y se impartirá en la sala <strong>${salas.filter(sala => sala.idSala == salaSeleccionada)[0].nombre}</strong><br><br>
                    ¿Los datos son correctos?
                     `,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText:
                'Aceptar',
            confirmButtonColor: '#14A7A3',
            cancelButtonText:
                'Modificar',
            preConfirm: () => {
                return {
                    idTurno: turno.idTurno,
                    idTerapeuta: turno.idTerapeuta,
                }
            },
            preDeny: () => {
                return {
                    idTurno: turno.idTurno,
                }
            },
        })
            .then(async (result) => {

                if (result.isConfirmed) {
                    handleUpdateText(turnoSeleccionado.idTurno)
                }

            });
    };

    return (
        <>
            {/* Badge mostrando el Ceseco asignado */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 0.75rem',
                background: '#f8f9fa',
                borderRadius: '6px',
                border: '1px solid #e9ecef',
                fontSize: '0.875rem',
                color: '#495057',
                marginBottom: '1rem',
                maxWidth: 'fit-content'
            }}>
            <span style={{
                fontSize: '0.875rem',
                color: '#6c757d',
                fontWeight: 500
            }}>
                Ceseco:
            </span>
            <span style={{
                fontWeight: 600,
                color: '#212529'
            }}>
                        {usuarioLegued?.categorias && usuarioLegued.categorias.length > 0
                            ? usuarioLegued.categorias.map(c => c.categoria).join(', ')
                            : (usuarioLegued?.categoria || 
                               categorias.find(cat => cat.idCategoria === usuarioLegued?.idCategoria)?.categoria || 
                               'Sin asignar')}
            </span>
            </div>
            <div className='grapBtns'>
                <button className="excel"> <FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                <button className="pdf"><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                <div className='inputsColumn'>
                    <input
                        type="text"
                        placeholder="Buscar por DNI, nombre o teléfono"
                        value={filterText}
                        onChange={handleFilterChange}
                        style={{
                            width: '15rem',

                        }}
                    />
                </div>
                {loading ? (
                    <></>
                ) : usuarioLegued?.idUsuario ? (
                    <>

                        {
                            (usuarioLegued?.rol === 'admin' || usuarioLegued?.rol === 'direccion') ? (
                                <>
                                    <div style={{ display: 'flex', width: '100%', maxWidth: '350px' }}>
                                        <div style={{ width: '100%', maxWidth: '350px' }}>
                                            <Select
                                                options={categorias.map(categoria => ({ value: categoria.idCategoria, label: categoria.categoria })) || []}
                                                value={categoriaFiltrada}
                                                onChange={(selectedOption) => setCategoriaFiltrada(selectedOption)}
                                                styles={customStyles}
                                                placeholder="Seleccionar Ceseco"
                                                isClearable
                                                maxMenuHeight={350}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuShouldBlockScroll={true}
                                            />
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', width: '100%', maxWidth: '350px' }}>
                                        <div style={{ width: '100%', maxWidth: '350px' }}>
                                            <Select
                                                isMulti
                                                options={
                                                    categoriaFiltrada
                                                        ? servicios
                                                            .filter(servicio => servicio.idCategoria === categoriaFiltrada.value)
                                                            .map(servicio => ({ value: servicio.idServicio, label: servicio.titulo }))
                                                        : servicios.map(servicio => ({ value: servicio.idServicio, label: servicio.titulo }))
                                                }
                                                value={serviciosFiltrados}
                                                onChange={(selectedOptions) => setServiciosFiltrados(selectedOptions)}
                                                styles={customStyles}
                                                placeholder="Servicios"
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                maxMenuHeight={350}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuShouldBlockScroll={true}
                                            />
                                        </div>
                                    </div>

                                    {
                                        (serviciosFiltrados.length > 0 || categoriaFiltrada) &&
                                        <p onClick={() => { setServiciosFiltrados([]); setCategoriaFiltrada(null) }} style={{ color: 'red', textAlign: 'center', cursor: 'pointer' }}>Quitar Filtros</p>
                                    }
                                </>
                            ) : (
                                <>
                                    {/* Para terapeuta: agregar selector de Ceseco si tiene múltiples */}
                                    {usuarioLegued?.rol === 'terapeuta' && 
                                     usuarioLegued?.idCategorias && 
                                     usuarioLegued.idCategorias.length > 1 && (
                                        <div style={{ display: 'flex', width: '100%', maxWidth: '350px' }}>
                                            <div style={{ width: '100%', maxWidth: '350px' }}>
                                                <Select
                                                    options={categorias
                                                        .filter(cat => usuarioLegued.idCategorias.includes(cat.idCategoria))
                                                        .map(cat => ({ value: cat.idCategoria, label: cat.categoria }))}
                                                    value={categoriaFiltrada}
                                                    onChange={(selected) => setCategoriaFiltrada(selected)}
                                                    placeholder="Filtrar por Ceseco"
                                                    isClearable
                                                    styles={customStyles}
                                                    maxMenuHeight={350}
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    menuShouldBlockScroll={true}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    
                                    <div style={{ display: 'flex', width: '100%', maxWidth: '350px' }}>
                                        <div style={{ width: '100%', maxWidth: '350px' }}>
                                            <Select
                                                isMulti
                                                options={
                                                    categoriaFiltrada
                                                        ? servicios
                                                            .filter(servicio => {
                                                                if (servicio.idCategoria !== categoriaFiltrada.value) return false;
                                                                
                                                                // Para coord_ceseco: todos los servicios del Ceseco seleccionado
                                                                if (usuarioLegued?.rol === 'coord_ceseco') {
                                                                    return true;
                                                                }
                                                                
                                                                // Para coord_programa: solo servicios asignados
                                                                if (usuarioLegued?.rol === 'coord_programa') {
                                                                    return usuarioLegued?.idServicios?.includes(servicio.idServicio) || 
                                                                           usuarioLegued?.idServicio === servicio.idServicio;
                                                                }
                                                                
                                                                // Para admin y direccion: todos
                                                                return ['admin', 'direccion'].includes(usuarioLegued?.rol);
                                                            })
                                                            .map(servicio => ({ value: servicio.idServicio, label: servicio.titulo }))
                                                        : servicios
                                                            .filter(servicio => {
                                                                // Verificar que el servicio pertenezca a uno de los Cesecos asignados
                                                                const perteneceACeseco = usuarioLegued?.idCategorias?.includes(servicio.idCategoria) ||
                                                                                        servicio.idCategoria === usuarioLegued.idCategoria;
                                                                
                                                                if (!perteneceACeseco) return false;
                                                                
                                                                // Para coord_ceseco: todos los servicios de sus Cesecos
                                                                if (usuarioLegued?.rol === 'coord_ceseco') {
                                                                    return true;
                                                                }
                                                                
                                                                // Para coord_programa: solo servicios asignados
                                                                if (usuarioLegued?.rol === 'coord_programa') {
                                                                    return usuarioLegued?.idServicios?.includes(servicio.idServicio) || 
                                                                           usuarioLegued?.idServicio === servicio.idServicio;
                                                                }
                                                                
                                                                // Para admin y direccion: todos
                                                                return ['admin', 'direccion'].includes(usuarioLegued?.rol);
                                                            })
                                                            .map(servicio => ({ value: servicio.idServicio, label: servicio.titulo }))
                                                }
                                                value={serviciosFiltrados}
                                                onChange={(selectedOptions) => setServiciosFiltrados(selectedOptions)}
                                                styles={customStyles}
                                                placeholder="Servicios"
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                maxMenuHeight={350}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuShouldBlockScroll={true}
                                            />
                                        </div>
                                    </div>
                                    {
                                        (serviciosFiltrados.length > 0 || categoriaFiltrada) &&
                                        <p onClick={() => { setServiciosFiltrados([]); setCategoriaFiltrada(null) }} style={{ color: 'red', textAlign: 'center', cursor: 'pointer' }}>Quitar Filtros</p>
                                    }
                                </>
                            )
                        }
                        {
                            (usuarioLegued?.rol === 'admin' || 
                             usuarioLegued?.rol === 'coord_programa' || 
                             usuarioLegued?.rol === 'coord_ceseco' || 
                             usuarioLegued?.rol === 'direccion' || 
                             usuarioLegued?.rol === 'terapeuta') && (
                                <>

                                    <div style={{ display: 'flex', gap: '0.5rem', marginLeft: '1rem', marginBottom: '1rem' }}>
                                        {Helper.estadoFiltros
                                            .filter(filtro => filtro.key === 'asignado' || filtro.key === 'finalizado')
                                            .map(filtro => (
                                    <button
                                                    key={filtro.key}
                                                    className={selectedEstados.includes(filtro.key) ? 'btnSelected' : 'btnNoSelected'}
                                                    style={{
                                                        background: selectedEstados.includes(filtro.key) ? filtro.bg : '#f5f5f5',
                                                        color: selectedEstados.includes(filtro.key) ? filtro.color : '#333',
                                                        border: `1px solid ${filtro.border}`,
                                                        borderRadius: 8,
                                                        padding: '0.5rem 1.2rem',
                                                        fontWeight: 600,
                                                        boxShadow: selectedEstados.includes(filtro.key) ? `0 2px 8px ${filtro.bg}66` : 'none',
                                                        transition: 'all 0.2s',
                                                    }}
                                                    onClick={() => {
                                                        setSelectedEstados(prev =>
                                                            prev.includes(filtro.key)
                                                                ? prev.filter(e => e !== filtro.key)
                                                                : [...prev, filtro.key]
                                                        );
                                                    }}
                                                >
                                                    {filtro.label}
                                    </button>
                                            ))}
                                    </div>
                                </>
                            )
                        }
                    </>
                ) : (
                    <>
                        {
                            servicios?.map(item => {
                                const turnosPorServicio = turnos?.filter(turno => turno.idServicio === item.idServicio).length; // Calcular la cantidad de turnos para el servicio
                                return (
                                    <button
                                        key={item.idServicio}
                                        className={servicioSeleccionado === item.idServicio ? 'btnSelected' : 'btnNoSelected'}
                                        onClick={() => handleSelectServicio(item.idServicio)}
                                    >
                                        ({turnosPorServicio})  <span>{item.titulo} </span>
                                    </button>
                                );
                            })
                        }
                    </>
                )}

            </div>
            <p style={{ fontWeight: 'bold' }}>
                {
                    serviciosFiltrados.length === servicios.filter(servicio => {
                        const perteneceACeseco = usuarioLegued?.idCategorias?.includes(servicio.idCategoria) ||
                                                servicio.idCategoria === usuarioLegued.idCategoria;
                        if (!perteneceACeseco) return false;
                        
                        if (usuarioLegued?.rol === 'coord_ceseco') {
                            return true;
                        }
                        
                        if (usuarioLegued?.rol === 'coord_programa') {
                            return usuarioLegued?.idServicios?.includes(servicio.idServicio) ||
                                   usuarioLegued?.idServicio === servicio.idServicio;
                        }
                        
                        return ['admin', 'direccion'].includes(usuarioLegued?.rol);
                    }).length ? 'Todos los servicios' : `${serviciosFiltrados.map(obj => obj.label).join(',')}`
                }
            </p>
            <div className="calendario-disponibilidad">
                <FullCalendar
                    locale={esLocale}
                    schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
                    plugins={[resourceTimeGridPlugin]}
                    initialView="resourceTimeGridDay"
                    resources={resources}
                    events={events}
                    eventClick={handleSelectEvent}
                    slotLabelFormat={{
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false,
                    }}
                    slotMinTime="08:00:00"
                    slotMaxTime="24:00:00"
                    allDaySlot={false}
                    height="800px"
                />
                {/* Modal para mostrar los detalles del turno seleccionado */}
                {turnoSeleccionado && (
                    <TurnoModal
                        isOpen={modalIsOpen}
                        onClose={handleCloseModal}
                        turnoSeleccionado={turnoSeleccionado}
                        nombre={nombre}
                        setNombre={setNombre}
                        telefono={telefono}
                        setTelefono={setTelefono}
                        motivoInactivo={motivoInactivo}
                        setMotivoInactivo={setMotivoInactivo}
                        nuevaFecha={nuevaFecha}
                        setNuevaFecha={setNuevaFecha}
                        periodicidad={periodicidad}
                        setPeriodicidad={setPeriodicidad}
                        nuevaHoraInicio={nuevaHoraInicio}
                        setNuevaHoraInicio={setNuevaHoraInicio}
                        nuevaHoraFin={nuevaHoraFin}
                        setNuevaHoraFin={setNuevaHoraFin}
                        nuevoComentario={nuevoComentario}
                        setNuevoComentario={setNuevoComentario}
                        comentarioActualizado={comentarioActualizado}
                        cancelarActualizado={cancelarActualizado}
                        nuevoEstado={nuevoEstado}
                        setNuevoEstado={setNuevoEstado}
                        categorias={categorias}
                        categoriaSeleccionada={categoriaSeleccionada}
                        setCategoriaSeleccionada={setCategoriaSeleccionada}
                        servicioSeleccionado={servicioSeleccionado}
                        setServicioSeleccionado={setServicioSeleccionado}
                        terapeutaSeleccionado={terapeutaSeleccionado}
                        setTerapeutaSeleccionado={setTerapeutaSeleccionado}
                        salaSeleccionada={salaSeleccionada}
                        setSalaSeleccionada={setSalaSeleccionada}
                        citasSeleccionadas={citasSeleccionadas}
                        setCitasSeleccionadas={setCitasSeleccionadas}
                        alertAsignarSala={alertAsignarSala}
                        handleUpdateText={handleUpdateText}
                        handleUpdateDate={handleUpdateDate}
                        handleInsertComment={handleInsertComment}
                        handleCancelar={handleCancelar}
                    />
                )}
            </div>
        </>
    );
};

export default Disponibilidad;
